// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"510":"40021d3da16d03ef","519":"47ca21d9c05b06cc","563":"50aa80d97d848a7d","883":"df6f4cc096bdd195"}[chunkId] + ".css";
};